<sc-chat-groups *ngIf="!chatGroupID" (closeSidebar)="closeSidebar.emit()" [selectChatGroup]="selectChatGroup.bind(this)"></sc-chat-groups>

<sc-chat-group
  *ngIf="chatGroupID"
  (closeSidebar)="closeSidebar.emit()"
  [goBack]="back.bind(this)"
  [chatGroupID]="chatGroupID"></sc-chat-group>
